/**
 * Must be sorted from maximum to minimum accuracy
 */
export enum AccuracyEnum {
    HOUSE_NUMBER = 'houseNumber',
    STREET_NAME = 'streetName',
    CITY = 'city',
    STATE = 'state',
    COUNTRY = 'country',
}
